import { genCookieName, TDS_USER_ID, TDS_USER_NAME } from '@/config/hooks/user/utils';
import { AuthInfo, BUGLY_LOGIN_STORAGE_KEY } from '@/presentation/hooks/user/types';
import { getCookie } from '@raft/utils/src/cookie';

/**
 * 对于oa版本：从 cookie 获取当前登录的企业微信用户名
 * 对于外网版本：从localstorage里获取存储的用户id
 * ps：该值是 html 直出时注入到 cookie 的
 */
export function getUserId() {
  if (isPro() || isSgp())  return getCookie(genCookieName(TDS_USER_ID)) || '';
  if (isInternal()) return getStorageBuglyId();
  return getStaffName();
}

export function getStaffName() {
  let staffName = getCookie('buglyUserName') || '';
  staffName = staffName.replace(/"/g, '');
  return decodeURIComponent(staffName);
}


export function getUserName() {
  if (isPro() || isSgp())  return getCookie(genCookieName(TDS_USER_NAME)) || '';
  if (isInternal()) return getStorageBuglyName();

  return getStaffName();
}

/**
 * 获取当前登录用户头像
 */
export function getAvatar(): string {
  if (!isInternal()) {
    const userName = getStaffName();
    return userName ? `https://r.hrc.woa.com/photo/100/${userName}.png` : '';
  }

  const userName = getStorageBuglyName();
  return genAvatar(userName);
}

/**
 * 根据用户名生成随机背景的头像
 * 正方形
 * @param userName
 * @param size
 */
export function genAvatar(userName: string, size = 48): string {
  const color = randomColor(userName);
  const center = size / 2;

  const firstChar = userName.substring(0, 1);
  const cvs = document.createElement('canvas');
  cvs.setAttribute('width', `${size}`);
  cvs.setAttribute('height', `${size}`);
  const context = cvs.getContext('2d');

  if (context) {
    context.fillStyle = color;
    context.fillRect(0, 0, size, size);
    context.fillStyle = '#fff';
    context.font = `${size * 0.5}px TencentSans`;
    context.textBaseline = 'middle';
    context.textAlign = 'center';
    context.fillText(firstChar, center, center);
  }

  return cvs.toDataURL('image/jpeg', 1);
};

const randomColor = (userName: string) => {
  let color = '';
  // eslint-disable-next-line @typescript-eslint/prefer-for-of
  for (let i = 0; i < userName.length; i++) {
    color += parseInt(String(userName[i].charCodeAt(0)), 10).toString(16);
  }

  return `#${color.slice(1, 4)}`;
};

/**
 * 是否外网版本
 */
export function isInternal() {
  return process.env.APP_VERSION === 'internal';
}

export function isWOA() {
  return process.env.APP_VERSION === 'woa';
}

export function isSgp() {
  return process.env.APP_VERSION === 'sgp';
}

export function isPro() {
  return process.env.APP_VERSION === 'pro';
}

export function isProOrSgp() {
  return isPro() || isSgp();
}

/**
 * 获取buglyId
 * 在组件内可以通过useAuth的hooks获取，不需要从这里取
 */
export function getStorageBuglyId(): string {
  const authInfo = getStorageAuthInfo();
  return authInfo?.userInfo?.buglyUserId ?? '';
}

export function getStorageBuglyName(): string {
  const authInfo = getStorageAuthInfo();
  return decodeURIComponent(authInfo?.userInfo?.buglyUserName ?? '');
}

// export function getStorageToken() {
//   try {
//     const authInfo = getStorageAuthInfo();
//     return authInfo?.token?.buglyToken;
//   } catch (e) {
//     return null;
//   }
// }

export function getStorageAuthInfo(): AuthInfo | null {
  try {
    return JSON.parse(localStorage.getItem(BUGLY_LOGIN_STORAGE_KEY) as string) as AuthInfo;
  } catch (e) {
    return null;
  }
}


